import { firstDayOfWeek } from '@enterprise/core';

/**
 * Calculates the date range covering the entire week of the given date.
 * The range starts from the first day of the week containing the given date,
 * and ends on the last day of that same week.
 *
 * @param date - A `Date` object representing any day within the target week.
 * @returns An object containing:
 *   - `startDate`: The `Date` of the first day of the week.
 *   - `endDate`: The `Date` of the last day of the week.
 */
export const useWeekRange = (date: Date) => {
  const dayOfWeek = firstDayOfWeek();
  const lastDayOfWeek = (dayOfWeek + 6) % 7;

  const startDay = new Date(date);
  const dayDiff = (date.getDay() - dayOfWeek + 7) % 7;

  startDay.setDate(startDay.getDate() - dayDiff);

  const endDay = new Date(date);
  const dayDiffEnd = (lastDayOfWeek - date.getDay() + 7) % 7;

  endDay.setDate(endDay.getDate() + dayDiffEnd);

  return { endDate: endDay, startDate: startDay };
};
